import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const SafetyFaceshieldPpe = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25 8H20.433C18.83 5.623 16.15 4.04 13.119 4.001C13.079 4 13.039 4 12.999 4C10.616 4 8.376 4.919 6.678 6.595C4.951 8.299 4 10.574 4 13C4 17.032 5.253 19.512 6.359 21.7C7.24 23.443 8 24.948 8 27C8 27.552 8.448 28 9 28C9.552 28 10 27.552 10 27C10 24.471 9.098 22.687 8.144 20.798C7.193 18.915 6.213 16.975 6.031 14H12.001V23C12.001 25.757 14.244 28 17.001 28H23.001C25.758 28 28.001 25.757 28.001 23V11C28.001 9.346 26.655 8 25.001 8H25ZM6.071 12C6.285 10.494 6.98 9.106 8.082 8.018C9.425 6.693 11.201 5.981 13.093 6C14.934 6.024 16.608 6.784 17.847 7.999H15.999C13.793 7.999 11.999 9.793 11.999 11.999H6.07L6.071 12ZM26 23C26 24.654 24.654 26 23 26H17C15.346 26 14 24.654 14 23V12C14 10.897 14.897 10 16 10H19.285C19.742 10.944 20 12.003 20 13.119V14.185C20 14.424 20.085 14.655 20.241 14.836L21.655 16.486C21.672 16.505 21.689 16.524 21.707 16.542C21.896 16.731 22 16.982 22 17.249C22 17.8 21.551 18.249 21 18.249C20.449 18.249 20 18.697 20 19.249V21.124C20 21.606 19.607 21.999 19.125 21.999H17C16.448 21.999 16 22.447 16 22.999C16 23.551 16.448 23.999 17 23.999H19.125C20.71 23.999 22 22.709 22 21.124V20.078C23.164 19.665 24 18.553 24 17.249C24 16.462 23.699 15.721 23.151 15.158L22 13.815V13.118C22 12.024 21.806 10.974 21.453 9.999H25C25.551 9.999 26 10.448 26 10.999V22.999V23Z" />
	</svg>
);

export default SafetyFaceshieldPpe;
